import React from 'react';
import ClientContent from 'components/root/client/ClientContent';

export const ClientPage: React.FC = () => {
  return <ClientContent />;
};
